import { css } from 'styled-components';

export const scrollbarStyles = {
  default: css`
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.colors.grey[600]} transparent;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.grey[600]};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.colors.grey[500]};
    }
  `,
  thin: css`
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.colors.grey[500]} transparent;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.grey[500]};
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.colors.grey[400]};
    }
  `,
  horizontal: css`
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.colors.grey[600]} transparent;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 6px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.grey[600]};
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.colors.grey[500]};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
      &::-webkit-scrollbar {
        display: none;
      }
    }
  `,
  hidden: css`
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
  `,
};

export const scrollbarCSSClasses = `
  .scrollbar-default {
    scrollbar-width: thin;
    scrollbar-color: #45474d transparent;
    -webkit-overflow-scrolling: touch;
  }

  .scrollbar-default::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .scrollbar-default::-webkit-scrollbar-track {
    background: transparent;
  }

  .scrollbar-default::-webkit-scrollbar-thumb {
    background: #45474d;
    border-radius: 3px;
  }

  .scrollbar-default::-webkit-scrollbar-thumb:hover {
    background: #5f5c66;
  }

  .scrollbar-thin {
    scrollbar-width: thin;
    scrollbar-color: #5f5c66 transparent;
    -webkit-overflow-scrolling: touch;
  }

  .scrollbar-thin::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  .scrollbar-thin::-webkit-scrollbar-track {
    background: transparent;
  }

  .scrollbar-thin::-webkit-scrollbar-thumb {
    background: #5f5c66;
    border-radius: 2px;
  }

  .scrollbar-thin::-webkit-scrollbar-thumb:hover {
    background: #9b9da3;
  }

  .scrollbar-horizontal {
    scrollbar-width: thin;
    scrollbar-color: #45474d transparent;
    -webkit-overflow-scrolling: touch;
  }

  .scrollbar-horizontal::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  .scrollbar-horizontal::-webkit-scrollbar-track {
    background: transparent;
  }

  .scrollbar-horizontal::-webkit-scrollbar-thumb {
    background: #45474d;
    border-radius: 4px;
  }

  .scrollbar-horizontal::-webkit-scrollbar-thumb:hover {
    background: #5f5c66;
  }

  @media (max-width: 1024px) {
    .scrollbar-horizontal::-webkit-scrollbar {
      display: none;
    }
  }

  .scrollbar-hidden {
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .scrollbar-hidden::-webkit-scrollbar {
    display: none;
  }
`;
